import React from 'react';
import Paper from '@material-ui/core/Paper';
import PlayIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import ShuffleIcon from '@material-ui/icons/Shuffle';
import RepeatOneIcon from '@material-ui/icons/RepeatOne';
import NextIcon from '@material-ui/icons/SkipNext';
import PrevIcon from '@material-ui/icons/SkipPrevious';
import PlaylistIcon from '@material-ui/icons/QueueMusic';
import Tooltip from '@material-ui/core/Tooltip';
import Slider from '@material-ui/core/Slider';
import Fab from '@material-ui/core/Fab';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { savePlayerConfig } from '../../redux/actions';
import styles from './PlayerStyles';
import { saveStats } from '../../redux/actions';

// Slider styling
//  root, colorPrimary, colorSecondary, marked, vertical, disabled, rail, track, trackFalse, trackInverted, thumb, thumbColorPrimary,
// thumbColorSecondary, active, focusVisible, valueLabel, mark, markActive, markLabel, markLabelActive

const PrettoSlider = withStyles({
  root: {
    color: '#52af77',
    width: 'calc(100% - 4px)',
    marginLeft: 2,
    height: 6,
  },
  rail: {
    height: 6,
    backgroundColor: '#7c8ad6',
  },
  track: {
    height: 6,
    borderRadius: 0,
    backgroundColor: '#7c8ad6',
  },
  thumb: {
    backgroundColor: '#fff',
    marginTop: -3,
  },
})(Slider);

class Player extends React.Component {
  files = false;
  interval = 0;

  constructor(props) {
    super(props);
    this.timeRef = React.createRef();
    this.state = {
      shuffle: false,
      repeatOne: false,
      playlist: true,
      time: 0,
      ...this.props.config
    };
  }

  componentDidMount() {
    const { media, stats } = this.props;
    if (!media) return;
    const { timeupdate, ended } = media.events;
    this.setState({ playingSubscribtion: timeupdate.subscribe(this.updateTime) });
    this.setState({ endedSubscribtion: ended.subscribe(this.fileStopped) });
    stats.startTime('MEDIA');
    this.interval = setInterval(() => {
      const time = stats.getTime();
      if (time > 30) {
        stats.resetTime();
        this.props.saveStats('MEDIA', time);
      }
    }, 60000);
  }

  componentDidUpdate() {
    if (!this.files && this.props.files) {
      this.files = [...this.props.files];
      if (this.state.shuffle) {
        this.shuffleFiles();
      }
      if (this.files?.length) {
        const file = this.files[0];
        this.props.setFile(file);
        this.props.media.setUrl(file.url);
      }
    }
  }

  componentWillUnmount() {
    this.state.playingSubscribtion.unsubscribe();
    this.state.endedSubscribtion.unsubscribe();
    const time = this.props.stats.stopTime();
    this.props.saveStats('MEDIA', time);
    clearInterval(this.interval);
  }

  updateTime = () => {
    const { media } = this.props;
    if (!media) return;
    const time = displayTime(media.getAudioTime());
    this.timeRef.current.textContent = time;
    this.setState({ time: media.getAudioTime() });
    this.props.stats.action();
  }

  toggleShuffle = () => {
    if (!this.state.shuffle) {
      this.shuffleFiles();
    } else {
      this.files = [...this.props.files];
    }
    this.saveConfig({ shuffle: !this.state.shuffle });
    this.setState({ shuffle: !this.state.shuffle });
  }

  toggleRepeatOne = () => {
    this.saveConfig({ repeatOne: !this.state.repeatOne });
    this.setState({ repeatOne: !this.state.repeatOne });
  }

  togglePlaylist = () => {
    this.saveConfig({ playlist: !this.state.playlist });
    this.setState({ playlist: !this.state.playlist });
  }

  shuffleFiles = () => {
    if (!this.props.files) return;
    const shuffled = [];
    const unshuffled = [...this.props.files];
    const len = unshuffled.length;
    for (let i = 0; i < len; ++i) {
      const idx = Math.round(Math.random() * (unshuffled.length - 1));
      const file = unshuffled.splice(idx, 1)[0];
      shuffled.push(file);
    }
    this.files = shuffled;
  }

  play = () => {
    this.props.media && this.props.media.play();
  }

  pause = () => {
    this.props.media && this.props.media.pause();
  }

  playNext = () => {
    const { media, status } = this.props;
    if (!media) return;
    let idx = this.findFileIndex() + 1;
    if (idx === this.files.length) idx = 0;
    const file = this.files[idx];
    media.setAudioTime(0);
    if (status === 'playing' || this.state.playlist) {
      this.props.play(file);
    } else {
      this.props.setFile(file);
    }
  }

  playPrev = () => {
    const { media, status } = this.props;
    if (!media) return;
    if (media && media.getAudioTime() > 5) {
      media.setAudioTime(0);
    } else {
      let idx = this.findFileIndex() - 1;
      if (idx < 0) idx = this.files.length - 1;
      const file = this.files[idx];
      media.setAudioTime(0);
      if (status === 'playing' || this.state.playlist) {
        this.props.play(file);
      } else {
        this.props.setFile(file);
      }
    }
  }

  findFileIndex = () => {
    return this.files.findIndex((file) => file.url === this.props.file.url);
  }

  fileStopped = () => {
    if (this.state.playlist && !this.state.repeatOne) {
      this.playNext();
    } else if (this.state.repeatOne) {
      this.play();
    }
  }

  changeTime = (ev, time) => {
    const { media } = this.props;
    if (!media) return;
    const time2 = parseFloat(time);
    if (time2 < media.getAudioDuration()) {
      this.setState({ time });
      media.setAudioTime(time2);
    }
  }

  saveConfig(data) {
    const { shuffle, repeatOne, playlist } = this.state;
    const config = { shuffle, repeatOne, playlist, ...data };
    this.props.savePlayerConfig(config);
  }

  render() {
    const { classes, status, file } = this.props;

    return (
      <Paper elevation={1} className={classes.paper}>
        <div className={classes.controls}>
          <Fab size="medium" aria-label="Add" onClick={this.playPrev}>
            <PrevIcon className={classes.mediumIcon} color="primary" />
          </Fab>
          {(status === 'paused' || status === 'ended') && <Fab size="large" aria-label="Add" onClick={this.play}>
            <PlayIcon className={classes.largeIcon} color="primary" />
          </Fab>}
          {status === 'playing' && <Fab size="large" aria-label="Add" onClick={this.pause}>
            <PauseIcon className={classes.largeIcon} color="primary" />
          </Fab>}
          {status === 'loading' && <Fab size="large" aria-label="Add">
            <PlayIcon className={classes.loading} color="primary" />
          </Fab>}
          <Fab size="medium" aria-label="Add" onClick={this.playNext}>
            <NextIcon className={classes.mediumIcon} color="primary" />
          </Fab>
        </div>
        <div className={classes.time}>
          <div ref={this.timeRef}>0:00</div>
          <div>{displayTime(this.props.media.getAudioDuration())}</div>
        </div>
        <div className={classes.display}>
          <div className={classes.title}>
            {file && <span>{file.title}</span>}
          </div>
          <PrettoSlider value={this.state.time} onChange={this.changeTime} max={this.props.media.getAudioDuration() || 100} />
        </div>

        <div className={classes.options}>
          <Tooltip title="playlista / pojedynczy utwór" >
            <PlaylistIcon onClick={this.togglePlaylist} style={{ opacity: this.state.playlist ? 1 : 0.4 }} />
          </Tooltip>
          <Tooltip title="losuj kolejność">
            <ShuffleIcon onClick={this.toggleShuffle} style={{ opacity: this.state.shuffle ? 1 : 0.4 }} />
          </Tooltip>
          <Tooltip title="powtarzaj pojedynczy utwór">
            <RepeatOneIcon onClick={this.toggleRepeatOne} style={{ opacity: this.state.repeatOne ? 1 : 0.4 }} />
          </Tooltip>
        </div>
      </Paper>
    );
  }
}

function displayTime(time) {
  if (isNaN(time)) return '0:00';
  const minutes = Math.floor(time / 60);
  const seconds = ('0' + Math.floor(time - minutes * 60)).substr(-2);
  return `${minutes}:${seconds}`;
}

const mapStateToProps = (state) => {
  return {
    config: state.config.player,
    media: state.media,
    stats: state.stats,
  }
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { savePlayerConfig, saveStats }),
)(Player);
